module.exports = __webpack_public_path__ + "static/media/AssociatesIconActive.32e92326.png";